module.exports = __webpack_public_path__ + "static/img/Garry-Jack.3dba7fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Garry-Jack.jpg
// module id = JPBw
// module chunks = 0